import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom'; // Import useNavigate for navigation
import axios from 'axios';
import { Form, Button, Alert } from 'react-bootstrap';
import './AdminCSS/operations.css'; // Keep this if you're using external CSS
// import { API_URL } from '../../config/config'; // Adjust the path as needed

const API_URL = process.env.REACT_APP_API_URL;


const AddUser = () => {
  const [userName, setUserName] = useState('');
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [message, setMessage] = useState('');
  const navigate = useNavigate(); // Initialize navigate
const handleSubmit = async (e) => {
  e.preventDefault();
  try {
    const token = sessionStorage.getItem('access_token') || localStorage.getItem('access_token');

    const response = await axios.post(
      `${API_URL}/users/addUser`,
      {
        user_name: userName,
        email: email,
        password: password,
      },
      {
        headers: {
          Authorization: `Bearer ${token}`,
          'Content-Type': 'application/json',
        },
      }
    );

    console.log(response.data);
    setMessage('User added successfully!');
    setUserName('');
    setEmail('');
    setPassword('');
  } catch (error) {
    if (error.response && error.response.status === 401) {
      setMessage('Unauthorized: Please log in again.');
      navigate('/login');
    } else {
      setMessage(error.response?.data?.detail || 'Error adding user');
    }
  }
};


  const handleClose = () => {
    navigate('/admindashboard'); // Replace with the correct route to the admin dashboard
  };

  return (
    <div className="add-user-wrapper">
      <div className="add-user-container">
      <div className="header">
          <h3>Add User</h3>
          <button className="close-button" onClick={handleClose}>
            &times;
          </button>
        </div>
        <Form onSubmit={handleSubmit}>
          <Form.Group>
            <Form.Label>User Name:</Form.Label>
            <Form.Control
              type="text"
              value={userName}
              onChange={(e) => setUserName(e.target.value)}
            />
          </Form.Group>
          <Form.Group>
            <Form.Label>Email:</Form.Label>
            <Form.Control
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
            />
          </Form.Group>
          <Form.Group>
            <Form.Label>Password:</Form.Label>
            <Form.Control
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
            />
          </Form.Group>
          <Button variant="primary" type="submit">
            Add User
          </Button>
        </Form>
        {message && <Alert variant="info">{message}</Alert>}
      </div>  
    </div>
  );
};

export default AddUser;
